import type { MemberType } from '@/components/People/PeopleFilterSelector';
import getInviteLink from './getInviteLink';
import getPublicUrl from './getPublicUrl';

export default function getTeamInviteLink(
  inviteCode?: string | null,
  memberType: MemberType = 'participant',
) {
  return getInviteLink({
    inviteCode,
    kind: 'team',
    memberType,
    publicUrl: getPublicUrl(),
  });
}
